module.exports = __webpack_public_path__ + "static/media/recipe-cheqr.d6c3d2f6.gif";